<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <el-form :model="articleForm" :rules="rules" ref="articleForm" label-width="100px" class="demo-noticeForm">
        <el-form-item label="文章标题：" prop="title">
         <el-input v-model="articleForm.title" placeholder="请输入文章名称"></el-input>
        </el-form-item>

        <el-form-item label="文章分类：" prop="mold">
          <el-select v-model="articleForm.mold" multiple placeholder="请选择文章分类(可多选)" style="width: 100%">
            <el-option
              v-for="item in moldList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文章内容：" prop="content">
          <VueUditorWrap v-model="articleForm.content" :config="myConfig"></VueUditorWrap>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" class="submit-btn" @click="submitForm('articleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils";
import {articleVideoDetail, questionCateList,  updateArticleVideo} from "@/api/study";

export default {
  name: "article-edit",
  data() {
    return {
      id: '',
      moldList: [],
      articleForm: {
        title: '',
        mold: [],
        content: '',
      },
      rules: {
        title: [{required: true, message: '请输入文章标题', trigger: 'blur'},],
        mold: [{type: 'array', required: true, message: '请至少选择一个文章分类', trigger: 'change'},],
        content: [{required: true, message: '请输入文章标题', trigger: 'blur'},],
      },
      myConfig: bdEditConfig()
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", '/home/article-list', "双暖为老 / 文章编辑", true);
    this.getList()
    if (Number(this.$route.params.id)) this.id = this.$route.params.id, this.getDetail()
  },
  components: {
    VueUditorWrap
  },
  methods: {
    //  获取详情
    async getDetail() {
      const res = await articleVideoDetail(this.$route.params.id)
      this.articleForm = {
        title: res.data.title,
        mold: res.data.cate_ids.split(',').map(Number),
        content: res.data.content,
      }
    },
    //  获取列表
    async getList() {
      const res = await questionCateList('', 1, 1000)
      this.moldList = res.data
    },

    //  提交文章
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitQuestion()
        }
      });
    },
    async submitQuestion() {
      let _state = await updateArticleVideo(
        this.articleForm.title,
        this.articleForm.mold.join(','),
        '',
        this.articleForm.content,
        '',
        '',
        1,
        this.id)
      this.$message.success(_state.info)
      this.$router.go(-1)
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
